export type Item = Record<string, any> & { id: string };

async function call<T>(path: string, init?: RequestInit): Promise<T> {
  const response = await fetch(`/api${path}`, {
    credentials: "include",
    headers: { "content-type": "application/json", ...(init?.headers ?? {}) },
    ...init
  });
  if (!response.ok) {
    const data = await response.json().catch(() => ({}));
    throw new Error(data.message ?? `请求失败：${response.status}`);
  }
  if (response.status === 204) return undefined as T;
  return response.json();
}

export const api = {
  get: <T>(path: string) => call<T>(path),
  tryGet: async <T>(path: string, fallback: T) => {
    try { return await call<T>(path); } catch { return fallback; }
  },
  post: <T>(path: string, value: unknown) => call<T>(path, { method: "POST", body: JSON.stringify(value) }),
  put: <T>(path: string, value: unknown) => call<T>(path, { method: "PUT", body: JSON.stringify(value) }),
  patch: <T>(path: string, value: unknown) => call<T>(path, { method: "PATCH", body: JSON.stringify(value) }),
  del: <T>(path: string, value?: unknown) => call<T>(path, { method: "DELETE", body: JSON.stringify(value ?? {}) })
};
